export default __webpack_public_path__ + "static/media/Cover-Letter-(General-Version-for-Senior-Developer).e8f74503.pdf";